import styled from "styled-components";

export const ContentBoxStyled = styled.div`
padding-top: 60px;
    .links{
        padding: 1rem;
        h3{
            text-align: center;
        }
        ol{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 1rem auto;
            gap: 0.6rem;
            cursor: pointer;
            li{
                color: ${({theme})=> theme === 'dark' ? '#fff' : '#0C1E28'};
                list-style-type: none;
                a{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 0.6rem;
                    color: ${({theme})=> theme === 'dark' ? '#fff' : '#0C1E28'};
                    text-decoration: underline;
                    &:hover{
                        text-decoration: none;
                    }
                }
            }
            
        }
        
    }
`;